export const ModalPosition = {
  TOP_LEFT: Symbol('TOP_LEFT'),
  TOP_CENTER: Symbol('TOP_CENTER'),
  TOP_RIGHT: Symbol('TOP_RIGHT'),
  CENTER_CENTER: Symbol('CENTER_CENTER'),
};
export * from './Modal';
export * from './ConfirmationModal';
export * from './ResizableModal';
export * from './SuccessModal';
